//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import angular from 'angular';
import React from 'react';

import makeAngularReactController from '@react-bridge/angular-react-widget';
import AutoApprovalEntryModal from '@streams/components/AutoApprovalEntryModal';

angular.module('curalate').component('autoApprovalEntryModal', {
  controller: makeAngularReactController(<AutoApprovalEntryModal />),
});
